module.exports = {"attributes":{"viewBox":"0 0 200 200","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M 99.921 2.533 L 130.399 66.886 L 198.642 77.171 L 149.253 127.21 L 160.935 197.938 L 99.921 164.558 L 38.85 197.938 L 50.532 127.21 L 1.143 77.171 L 69.385 66.886 L 99.921 2.533 Z\" id=\"Shape\" fill=\"#FFB723\"></path>"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/channel/onlinecasinoground.nl.svg
// module id = 1336
// module chunks = 0